import React, { useState, useContext } from 'react';
import { IcheerContext } from '../Context/AppContext'; // Adjust path as needed
import { LogIn, Activity, Eye, EyeOff, Mail } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
const LoginPage = () => {
    const navigate = useNavigate();
  const { host, setIsAdminLoggedIn } = useContext(IcheerContext);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const loginTeam = async (loginData) => {
    const response = await fetch(`${host}team/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(loginData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Login failed');
    }

    return response.json();
  };



  const handleLogin = async () => {
    if (!formData.email || !formData.password) {
      setMessage('Please fill in all fields');
      setMessageType('danger');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setMessage('Please enter a valid email address');
      setMessageType('danger');
       return;
    }

    setLoading(true);
    try {
      const response = await loginTeam(formData);
      setMessage('Login successful!');
      setMessageType('success');

      // Store login status
      localStorage.setItem('isAdminLoggedIn', 'true');
      localStorage.setItem('userEmail', formData.email);
      setIsAdminLoggedIn(true);

      console.log('Login successful:', response);
      navigate('/');

    } catch (error) {
      setMessage(error.message || 'Login failed');
      setMessageType('danger');
    }
    setLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center" style={{
      background: '#dc59a0'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-5">
            {/* Header */}
            <div className="text-center mb-4">
              <Logo/>

             
            </div>

            {/* Login Card */}
            <div className="card shadow-lg border-0" style={{ borderRadius: '15px' }}>
              <div className="card-header bg-white border-0 text-center py-4" style={{ borderRadius: '15px 15px 0 0' }}>
                <h4 className="mb-0 text-dark fw-bold">Welcome Back</h4>
                <p className="text-muted mb-0 mt-1">Sign in to your account</p>
              </div>

              <div className="card-body p-4">
                {message && (
                  <div className={`alert alert-${messageType} alert-dismissible border-0 shadow-sm`} role="alert">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">{message}</div>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setMessage('')}
                      ></button>
                    </div>
                  </div>
                )}

                <div className="mb-4">
                  <label htmlFor="email" className="form-label text-dark fw-semibold">
                    <Mail size={16} className="me-2" />
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control form-control-lg border-0 shadow-sm"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    onKeyPress={handleKeyPress}
                    placeholder="Enter your email"
                    style={{
                      backgroundColor: '#f8f9fa',
                      borderRadius: '10px',
                      padding: '12px 16px'
                    }}
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="password" className="form-label text-dark fw-semibold">
                    Password
                  </label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control form-control-lg border-0 shadow-sm"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      placeholder="Enter your password"
                      style={{
                        backgroundColor: '#f8f9fa',
                        borderRadius: '10px',
                        padding: '12px 45px 12px 16px'
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ border: 'none', background: 'none' }}
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-primary btn-lg w-100 fw-semibold shadow-sm mb-3"
                  onClick={handleLogin}
                  disabled={loading}
                  style={{
                    borderRadius: '10px',
                    padding: '12px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none'
                  }}
                >
                  {loading ? (
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="spinner-border spinner-border-sm me-2" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      Signing in...
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      <LogIn size={18} className="me-2" />
                      Sign In
                    </div>
                  )}
                </button>



                <div className="text-center">
                  <p className="text-muted mb-0">
                    Don't have an account?{' '}
                    <a
                      href="/register"
                      className="text-decoration-none fw-semibold"
                      style={{ color: '#667eea' }}
                    >
                      Create Account
                    </a>
                  </p>
                  <p className="text-muted mt-2">
                    Forgot your password?{' '}
                    <a
                      href="/reset-password"
                      className="text-decoration-none fw-semibold"
                      style={{ color: '#667eea' }}
                    >
                      Reset Password
                    </a>
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;